/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DOCUMENT, Component, ElementRef, Inject, Input, OnInit} from '@angular/core';

import {CreativeViewer} from '../../../components/util/creative-viewer';
import {Uuid} from '../../../components/util/uuid';
import adTemplate from './creative-container.html';

@Component({
  standalone: true,
  selector: 'adn-creative-rendered',
  template: '<div class="previewContainer clearRight"></div>'
})
export class CreativeRenderedComponent implements OnInit {
  @Input() creative: any;
  @Input() maxWidth: string;
  @Input() maxHeight: string;

  constructor(
    private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit(): void {
    const apiPreviewData = {
      creativeWidth: this.creative.width,
      creativeHeight: this.creative.height,
      creativeContent: adTemplate.replace('{{responseId}}', 'resp-' + Uuid.generate())
        .replace('{{{creativeId}}}', this.creative.id)
        .replace('{{{rt}}}', 'rt-' + Uuid.generate())
        .replace('{{{content}}}', this.creative.renderedHtml),
      center: true
    };

    const divContainer = this.elementRef.nativeElement.querySelector('.previewContainer');
    new CreativeViewer(this.document).viewCreative(divContainer, apiPreviewData);
  }
}
